import { InfoCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import styled from 'styled-components'

import { colours } from '@qflow/theme'
import { RECORD_STATUS } from '@qflow/constants'

export const AutoPublishFailureReason = ({
  autoPublishFailureReasons,
  recordStatus
}: {
  autoPublishFailureReasons: string[] | null
  recordStatus: string
}) => {
  const showFailureReason =
    (recordStatus == RECORD_STATUS.FAILED ||
      recordStatus == RECORD_STATUS.ESCALATED) &&
    autoPublishFailureReasons != null &&
    autoPublishFailureReasons.length > 0 &&
    !autoPublishFailureReasons.some(
      f => f.toLocaleLowerCase() == 'no template verification for this record'
    )

  const tooltipText = showFailureReason ? (
    <StyledUL>
      {autoPublishFailureReasons.map((reason, index) => (
        <li key={index}>{reason}</li>
      ))}
    </StyledUL>
  ) : null

  const tooltipStyles = {
    borderRadius: '5px',
    padding: '11px 13px 10px',
    color: colours.CORE_NAVY,
    boxShadow: '0px 2px 8px 0px #00000038'
  }

  return (
    showFailureReason && (
      <AutoPublishFailedContainer>
        Autopublish failed{' '}
        <Tooltip
          title={tooltipText}
          styles={{ body: tooltipStyles }}
          color={colours.WHITE}
          placement="right"
          overlayStyle={{ maxWidth: '500px' }}
        >
          <InfoCircleOutlined style={{ marginLeft: '0.5rem' }} />
        </Tooltip>
      </AutoPublishFailedContainer>
    )
  )
}

const AutoPublishFailedContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 3px 0;
  color: ${colours.RED};
  padding-left: 1rem;
`
const StyledUL = styled.ul`
  list-style-type: disc;
  padding-inline-start: 1rem;
`
